// extracted by mini-css-extract-plugin
module.exports = {"admin-log-browser":"LogBrowser--admin-log-browser","adminLogBrowser":"LogBrowser--admin-log-browser"};